module.exports = __webpack_public_path__ + "media/images/lb/229-eacf7943afdc75790269e6ab5031328a.svg";